let map;
let markers = [];
let userMarker = null;
let infoWindow = null;
let autocomplete = null;

// SVP pour le pin Google Maps
const pinSvgPath = "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z";

// Dictionnaire de traductions
const translations = {
  fr: {
    yourPosition: "Votre position",
    addressNotFound: "Adresse introuvable.",
    noDealerFound: "Aucun concessionnaire trouvé dans un rayon de",
    itinerary: "Trouver itinéraire",
    clickToSee: "Cliquer pour voir sur la carte"
  },
  en: {
    yourPosition: "Your position",
    addressNotFound: "Address not found.",
    noDealerFound: "No dealer found in a radius of",
    itinerary: "Find itinerary",
    clickToSee: "Click to view on map"
  }
};

// On sélectionne la bonne langue (Anglais par défaut si non défini)
const lang = window.shopLocale || 'en';
const t = translations[lang];

window.initLocator = function() {
  map = new google.maps.Map(document.getElementById("dealer-map"), {
    center: { lat: 46.8000, lng: -71.1833 },
    zoom: 10,
  });

  infoWindow = new google.maps.InfoWindow();

  const inputElement = document.getElementById('address-input');
  autocomplete = new google.maps.places.Autocomplete(inputElement, {
    fields: ["geometry", "name"],
    types: ["geocode"],
    componentRestrictions: { country: "ca" } 
  });

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    if (!place.geometry || !place.geometry.location) {
      processSearch();
      return;
    }
    updateUserMarkerAndSearch(place.geometry.location);
  });

  document.getElementById('search-btn').addEventListener('click', processSearch);

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLat = position.coords.latitude;
        const userLng = position.coords.longitude;
        updateUserMarkerAndSearch(new google.maps.LatLng(userLat, userLng));
      },
      () => { console.log("Geolocation denied."); }
    );
  }
}

// Mettre à jour le point de base de la recherche
function updateUserMarkerAndSearch(location) {
  if (userMarker) { userMarker.setMap(null); }
      
  userMarker = new google.maps.Marker({
    position: location,
    map: map,
    title: t.yourPosition,
    icon: {
      path: pinSvgPath,
      fillColor: "#000000",
      fillOpacity: 1,
      strokeWeight: 1.5,
      strokeColor: "#FFFFFF",
      scale: 2,
      anchor: new google.maps.Point(12, 22)
    }
  });

  findNearestDealers(location.lat(), location.lng());
}

// Lancer la recherche
async function processSearch() {
  const address = document.getElementById('address-input').value;
  if (!address) return;

  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: address }, (results, status) => {
    if (status === "OK") {
      updateUserMarkerAndSearch(results[0].geometry.location);
    } else {
      alert(t.addressNotFound);
    }
  });
}

// Trouver les dealers les plus proches dans un rayon de 1000 km (5 maximum)
function findNearestDealers(userLat, userLng) {
  const radiusKm = 1000;
  let nearbyDealers = window.dealersData.map(dealer => {
    const dist = calculateDistance(userLat, userLng, dealer.lat, dealer.lng);
    return { ...dealer, distance: dist };
  });

  nearbyDealers = nearbyDealers
    .filter(d => d.distance <= radiusKm)
    .sort((a, b) => a.distance - b.distance)
    .slice(0, 5);

  displayResults(nearbyDealers, radiusKm);
}

// Calculer la distance entre deux points
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; 
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

// Présenter les résultats à gauche en liste et à droite dans la carte
function displayResults(dealers, radiusKm) {
  const list = document.getElementById('results-list');
  list.innerHTML = "";
  
  markers.forEach(m => m.setMap(null));
  markers = [];

  if (dealers.length === 0) {
    list.innerHTML = `<p>${t.noDealerFound} ${radiusKm} km.</p>`;
    return;
  }

  const bounds = new google.maps.LatLngBounds();
  if (userMarker) { bounds.extend(userMarker.getPosition()); }

  dealers.forEach(dealer => {
    const item = document.createElement('div');
    item.className = "dealer-item";
    
    // HTML pour le logo dans la liste
    const listLogoHtml = dealer.logo 
      ? `<img src="${dealer.logo}" alt="Logo ${dealer.name}" style="width: auto; max-width: 240px; max-height: 120px; object-fit: contain; margin: 15px 0; display: block; align-self: flex-start; margin-left: 0; margin-right: 0;">` 
      : ``;

    item.innerHTML = `
      <div class="dealer-distance-col">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="#EA6304"><path d="${pinSvgPath}"/></svg>
        <span class="distance-text">${dealer.distance.toFixed(1)} km</span>
      </div>
      <div class="dealer-info-col" style="flex-grow: 1; align-items: flex-start;">
        <h3 class="dealer-title" title="${t.clickToSee}">${dealer.name}</h3>
        <p class="dealer-address">${dealer.address}<br>${dealer.city}, ${dealer.zip}</p>
        <p class="dealer-phone" style="margin-top: 0;">${dealer.phone}</p>
        
        ${listLogoHtml}
      </div>
    `;
    list.appendChild(item);

    const pos = { lat: dealer.lat, lng: dealer.lng };
    const marker = new google.maps.Marker({
      position: pos,
      map: map,
      title: dealer.name,
      icon: {
        path: pinSvgPath,
        fillColor: "#EA6304", 
        fillOpacity: 1,
        strokeWeight: 1,
        strokeColor: "#FFFFFF",
        scale: 1.4,
        anchor: new google.maps.Point(12, 22)
      }
    });
    markers.push(marker);
    bounds.extend(pos);

    // Lien pour l'itinéraire (Ouvre Google Maps)
    const directionsUrl = `http://maps.google.com/maps?daddr=${dealer.lat},${dealer.lng}`;
    
    // Info-bulle pour proposer l'itinéraire et l'endroit exact du dealer
    const popupLogoHtml = dealer.logo 
      ? `<div style="margin-bottom: 10px;"><img src="${dealer.logo}" alt="Logo ${dealer.name}" style="max-width: 180px; max-height: 90px; object-fit: contain;"></div>` 
      : ``;

    const infoContent = `
      <div style="padding: 2px; font-family: sans-serif; min-width: 200px; max-width: 250px;">
        <div style="margin: 0 0 5px 0; padding-right: 24px; color: #000000; font-size: 15px; font-weight: 900; line-height: 1.1;">
          ${dealer.name}
        </div>
        <p style="margin: 0 0 5px 0; font-size: 13px;">${dealer.address}, ${dealer.city}</p>
        <p style="margin: 0 0 12px 0; font-size: 13px; font-weight: bold;">${dealer.phone}</p>
        ${popupLogoHtml}
        <a href="${directionsUrl}" target="_blank" style="display: block; text-align: center; background: #EA6304; color: #fff; padding: 10px; text-decoration: none; border-radius: 4px; font-size: 13px; font-weight: bold;">
          ${t.itinerary} 
        </a>
      </div>
    `;

    marker.addListener('click', () => {
      infoWindow.setContent(infoContent);
      infoWindow.open(map, marker);
      map.panTo(marker.getPosition());
    });

    item.querySelector('.dealer-title').addEventListener('click', () => {
      google.maps.event.trigger(marker, 'click');
      document.getElementById('dealer-map').scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  map.fitBounds(bounds);
}